
<div *ngIf="si;else loading">

      <div class="tab">
        <div *ngFor="let video of videos; index as i">
            <button class="tablinks" (click)="openVideo(video, i)" id="{{i}}"> video {{i+1}}</button>
        </div>
        <div>
            <button class="tablinks" (click)="openVideo('ultimoDiv', 'ultima')" id="ultima">Final</button>
        </div>
    </div>

    <div *ngFor="let video of videos; index as i">
        <div id="{{video}}" class="tabcontent">
              <p>estas viendo el video numero {{i+1}} </p> 
              <!-- <mat-video [quality]="false" spinner="hourglass" src="{{video}}"></mat-video> -->
              <!-- <video id="vide" controls controlsList="nodownload">
                <source src="{{video}}">
              Your browser does not support the video tag.
              </video> -->
              <iframe width="560" height="315" [src]="video | html" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        
    </div>
      
    <div id="ultimoDiv" class="tabcontent">
        <p>Muy Bien! terminaste el curso! ahora dejanos ver que hiciste, subi el link de GitHub de tu proyecto terminado
          a continuacion
          y pronto lo corregiremos!
        </p>
        <p>
          el link sera algo asi: "https://github.com/NOMBRE-DE-USUARIO/NOMBRE DEL PROYECTO"
        </p>
        <input type="text" [(ngModel)]="link" style="width: 100%;"> <button (click)="enviar()">Enviar!</button>
    </div>
</div>

<ng-template #loading>
    
    <div class="container-spinner">
       <mat-spinner color="warn"></mat-spinner>
    </div>
</ng-template>



<footer id="dudas">
  <p>Tienes dudas? no dudes en contarnos cualquier consulta <a href="mailto:hellocode.equipo@gmail.com?subject=Duda%20en%20Curso">Aqui</a>!</p> 
</footer>